/** @format */

import React from 'react';
import { createTheme, ThemeProvider, Theme } from '@material-ui/core/styles';
import COLORS from './colors';
import { CssBaseline } from '@material-ui/core';
import HelvNeue55_Cyr from './fonts/HelvNeue55_Cyr.ttf';
import HelvNeue75_Cyr from './fonts/HelvNeue75_Cyr.ttf';

const helvNeue55 = {
    fontFamily: '"Helvetica 55 Roman"',
    fontStyle: 'normal',
    fontWeight: 400,
    src: `
    local('Helvetica 55 Roman'),
    local('Helvetica 55 Roman'),
    url(${HelvNeue55_Cyr}) format('truetype')
  `,
};

const helvNeue75 = {
    fontFamily: '"Helvetica 75"',
    fontStyle: 'normal',
    fontWeight: 400,
    src: `
    local('Helvetica 75'),
    local('Helvetica 75'),
    url(${HelvNeue75_Cyr}) format('truetype')
  `,
};
const themeDark = createTheme({
    palette: {
        primary: {
            main: COLORS.MAIN.PRIMARY,
        },
        secondary: {
            main: COLORS.MAIN.SECONDARY,
        },
    },
    typography: {
        fontFamily: '"Helvetica 55 Roman", "Helvetica 75", "Arial"',
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [helvNeue55, helvNeue75],
                body: {
                    fontFamily: '"Helvetica 55 Roman", "Helvetica 75", "Arial"',
                },
                'h1,h2,h3,h4,h5,h6': {
                    margin: 0,
                    textTransform: 'none',
                    fontFamily: '"Helvetica 75", "Helvetica 55 Roman","Arial"',
                },
            },
        },
    },
});

const themeLight = createTheme({
    palette: {
        primary: {
            main: COLORS.MAIN.PRIMARY,
        },
    },
});

const OplTheme = (props: { children: any }): React.ReactElement => {
    return (
        <ThemeProvider theme={themeDark}>
            <CssBaseline />
            {props.children}
        </ThemeProvider>
    );
};

export default OplTheme;
